export enum ExternalIntegrationProvider {
  VIESION = "VIESION",
  FT = "france-travail",
  NEOLINK = "NEOLINK",
}

export enum ExternalIntegrationStatus {
  PENDING = "pending",
  SUCCESS = "success",
  ERROR = "error",
}

export interface IExternalIntegration {
  externalId?: string;
  provider: ExternalIntegrationProvider;
  status: ExternalIntegrationStatus;
  deleted: boolean;
  deletedAt?: Date;
  updatedAt: Date;
  createdAt: Date;
  // Raw provider error of the latest sync attempt, decorated by the API on ERROR integrations only.
  error?: string;
}
